import {
  Column,
  InvoiceBackdrop,
  InvoicePanel,
  Row,
} from "./customerSettings.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Color } from "config/colors";
import { Text } from "components/Typography/text.styled";
import { TextInput } from "components/form/inputs/inputs.styled";
import { useState } from "react";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CompanyCustomer } from "model/Company";
import { useTranslation } from "react-i18next";
import { FontFamily } from "config/font";

type Props = {
  setShowAddCustomerForm: React.Dispatch<React.SetStateAction<boolean>>;
  showAddCustomerForm: boolean;
  saveCustomer(customer: any): void;
};

export const AddCustomerForm: React.FC<Props> = ({
  setShowAddCustomerForm,
  showAddCustomerForm,
  saveCustomer,
}) => {
  const { t } = useTranslation();

  const [companyState, companyActions] = useCompanyStore();
  const [customerName, setCustomerName] = useState("");
  const [customerOrgNr, setCustomerOrgNr] = useState("");
  const [customerContact, setCustomerContact] = useState("");

  const onClose = () => setShowAddCustomerForm(false);

  return (
    <>
      <InvoiceBackdrop open={showAddCustomerForm} onClick={onClose} />
      <InvoicePanel open={showAddCustomerForm}>
        <Row>
          <Column>
            <Text
              style={{
                fontFamily: FontFamily.MontserratSemiBold,
                fontSize: "1.5rem",
              }}
            >
              {t("CompanyCustomers.AddCustomer")}
            </Text>
          </Column>
          <Column style={{ alignItems: "flex-end" }}>
            <Text
              style={{ cursor: "pointer", fontSize: "1.2rem" }}
              onClick={onClose}
            >
              ✕
            </Text>
          </Column>
        </Row>

        <Row>
          <Column>
            <Text>{t("CompanyCustomers.Name")}</Text>
            <TextInput onChange={(e) => setCustomerName(e.target.value)} />
          </Column>
          <Column>
            <Text>{t("CompanyCustomers.OrganizationNumber")}</Text>
            <TextInput onChange={(e) => setCustomerOrgNr(e.target.value)} />
          </Column>
        </Row>
        <Row>
          <Column>
            <Text>{t("CompanyCustomers.Contact")}</Text>
            <TextInput onChange={(e) => setCustomerContact(e.target.value)} />
          </Column>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Column>
            <ButtonStyled
              fullWidth
              backgroundColor={Color.MidnightBlue}
              onClick={onClose}
            >
              {t("General.Close")}
            </ButtonStyled>
          </Column>
          <Column>
            <ButtonStyled
              disabled={!customerContact || !customerName || !customerOrgNr}
              fullWidth
              backgroundColor={Color.BurntSienna}
              onClick={() => {
                let companyId = companyState.company?.id;
                if (companyId) {
                  let customer: CompanyCustomer = {
                    companyId: companyId,
                    name: customerName,
                    organizationNumber: customerOrgNr,
                    contact: customerContact,
                  };
                  saveCustomer(customer);
                  setShowAddCustomerForm(false);
                }
              }}
            >
              {t("General.Save")}
            </ButtonStyled>
          </Column>
        </Row>
      </InvoicePanel>
    </>
  );
};
